<template>
  <div id="MakerSpaceWordDetail" v-loading="loading">
    <MakerSpaceWord :wordData="wordData" v-if="state == 0" />
    <MakerSpaceWordShow
      ref="myChild"
      :wordData="wordData"
      v-if="state != 0 || downloadDig"
    />
    <div>
      <el-button type="primary" @click="downWordDig = true"
        >下载表格(word)</el-button
      >
      <el-button type="primary" @click="downloadDig = true"
        >下载表格(pdf)</el-button
      >
      <el-button type="primary" @click="test" v-if="state == 0"
        >立即修改</el-button
      >
    </div>
    <el-dialog
      title="提示"
      :visible.sync="submitHint"
      width="600px"
      class="pageSubmitData"
    >
      <div class="deleteContent">
        确定修改“{{ wordData["projectName"] }}”项目？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeWord" class="AllDialogBtn"
          >确认修改</el-button
        >
        <el-button @click="submitHint = false" class="AllDialogBtn"
          >取消</el-button
        >
      </span>
    </el-dialog>

    <!-- 下载文档开始 -->
    <el-dialog
      title="下载文档"
      :visible.sync="downloadDig"
      width="600px"
      class="pageSubmitData"
    >
      <div class="deleteContent">确定下载文档?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getPdf" class="AllDialogBtn"
          >确认</el-button
        >
        <el-button @click="downloadDig = false" class="AllDialogBtn"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 下载文档结束-->
    <!-- 下载文档开始 -->
    <el-dialog
      title="下载文档"
      :visible.sync="downWordDig"
      width="600px"
      class="pageSubmitData"
    >
      <div class="deleteContent">确定下载文档?</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getWord" class="AllDialogBtn"
          >确认</el-button
        >
        <el-button @click="downloadDig = false" class="AllDialogBtn"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <!-- 下载文档结束-->
  </div>
</template>

<script>
import MakerSpaceWord from "./MakerSpaceWord.vue";
import MakerSpaceWordShow from "./MakerSpaceWordShow.vue";
import { getMakerSpaceWord } from "@/components/tool/getWord";
import { downloadPDF } from "@/components/tool/pdf";
export default {
  components: { MakerSpaceWord, MakerSpaceWordShow },
  data() {
    return {
      downloadDig: false,
      downWordDig:false,
      wordData: {
        applicationDate: "", //申请日期
        projectName: "", //项目名称
        college: "", //所在学院
        collegeName: "",
        begin_at: "", //项目开始时间
        state: "", //项目状态
        stateName: "", //项目状态名称
        plannedEnd_at: "", //计划完成时间
        pro_leader: "", //项目负责人
        lead_leader: "", //学院牵头领导
        teacher: [
          {
            name: "",
            speciality: "",
            title: "",
            education: "",
            section: "",
            work: "",
          },
          {
            name: "",
            speciality: "",
            title: "",
            education: "",
            section: "",
            work: "",
          },
          {
            name: "",
            speciality: "",
            title: "",
            education: "",
            section: "",
            work: "",
          },
        ], //教师组//name：姓名  speciality：专业  title：职称 education：学历    section：所在教研室    work：项目组角色分工
        student: [
          { name: "", class: "", age: "", work: "" },
          { name: "", class: "", age: "", work: "" },
          { name: "", class: "", age: "", work: "" },
          { name: "", class: "", age: "", work: "" },
          { name: "", class: "", age: "", work: "" },
        ], //学生组//name：姓名    class：班级 age：年龄   work：项目组任务分工
        brief: "", //项目简介
        Construction: "", //建设内容
        ProjectBasis: "", //立项依据
        development: "", //创客空间物理环境、制度建设及软件设施建设情况
        studio: "", //学生创客工作室建设情况
        studentTeam: "", //学生创客团队（人才）培养预期成果、数量
        studentActivities: "", //学生创客活动组织实施情况
        Transforming: "", //学生创客团队孵化、转化创业项目情况
        condition: "", //立 项基 础及条 件
        fund: {
          total: "",
          device: "",
          Material: "",
          processing: "",
          Collaboration: "",
          APPRAISAL: "",
          entery: "",
          activities: "",
          Transaction: "",
        },
      },
      state: 1,
      loading: false,
      submitHint: false,
    };
  },
  methods: {
    getData() {
      this.loading = true;
      this.ajax
        .get(this.$store.state.api + "/getMakerSpaceWordData", {
          uid: this.$store.state.userInfo.userid,
          pid: this.$route.query["pid"],
        })
        .then((result) => {
          let data = result["data"][0][0];
          this.wordData["projectName"] = data["title"];
          this.wordData["applicationDate"] = data["applyProjectTime"];
          this.wordData["college"] = data["classid"];
          this.wordData["collegeName"] = data["cName"];
          this.wordData["begin_at"] = data["begintime"];
          this.wordData["state"] = data["typeName"];
          this.wordData["stateName"] = data["tName"];
          this.wordData["plannedEnd_at"] = data["planTime"];
          this.wordData["pro_leader"] = data["pro_leader"];
          this.wordData["lead_leader"] = data["lead_leader"];
          this.wordData["teacher"] = JSON.parse(data["course_teacher"]);
          this.wordData["student"] = JSON.parse(data["course_student"]);
          this.wordData["brief"] = data["brief"];
          this.wordData["fund"] = JSON.parse(data["money"]);
          this.wordData["fund"].total =
            this.wordData["fund"].device +
            this.wordData["fund"].Material +
            this.wordData["fund"].processing +
            this.wordData["fund"].Collaboration +
            this.wordData["fund"].APPRAISAL +
            this.wordData["fund"].entery +
            this.wordData["fund"].activities +
            this.wordData["fund"].Transaction;
          this.state = data["isupload"];
          this.wordData = { ...this.wordData, ...JSON.parse(data["chapters"]) };
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPdf(){
      downloadPDF(
        this.$refs.myChild.$refs.downPDF,
        "附件3：2023年二级学院特色创客空间建设项目申报书"
      );
      this.downloadDig = false;
    },
    getWord() {
      //下载表格
      // console.log(this.$refs.myChild.$refs.downPDF)
      getMakerSpaceWord(this.wordData);
			this.downWordDig = false;
    },
    changeWord() {
      //修改表格数据
      this.loading = true;
      let pram = {
        uid: this.$store.state.userInfo.userid, //用户ID
        pid: this.$route.query["pid"],
        tit: this.wordData["projectName"], //项目名称
        bf: this.wordData["brief"], //项目简介
        pLeader: this.wordData["pro_leader"], //项目负责人
        lLeader: this.wordData["lead_leader"], //学院牵头领导,
        cid: this.wordData["college"], //学院ID,
        ct: JSON.stringify(this.wordData["teacher"]), //教师组,
        cs: JSON.stringify(this.wordData["student"]), //学生组,
        f: this.wordData["fund"]["total"], //总经费
        chp: JSON.stringify({
          Construction: this.wordData["Construction"], //建设内容
          ProjectBasis: this.wordData["ProjectBasis"], //立项依据
          development: this.wordData["development"], //创客空间物理环境、制度建设及软件设施建设情况
          studio: this.wordData["studio"], //学生创客工作室建设情况
          studentTeam: this.wordData["studentTeam"], //学生创客团队（人才）培养预期成果、数量
          studentActivities: this.wordData["studentActivities"], //学生创客活动组织实施情况
          Transforming: this.wordData["Transforming"], //学生创客团队孵化、转化创业项目情况
          condition: this.wordData["condition"], //立 项基 础及条 件
        }).replaceAll(/%/g, "%25"), //项目详细
        tName: this.wordData["state"], //项目状态
        mon: JSON.stringify(this.wordData["fund"]), //预算经费
        planEnd: this.wordData["plannedEnd_at"], //计划完成时间,
        beh: this.wordData["begin_at"], //项目开始时间,
        mem: this.wordData["student"].length + this.wordData["teacher"].length, //项目组人数
      };
      this.ajax
        .post(this.$store.state.api + "/updateMakerSpaceWordData", pram)
        .then((result) => {
          console.log(result);
          if (result["data"] == 1) {
            this.$message.success("修改项目信息成功");
            this.submitHint = false;
          } else {
            this.$message.error("修改项目信息失败");
          }
          this.getData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    test() {
      //项目提交
      //检查各个字段
      const cEmpty = /^\s*$/g;
      for (let i in this.wordData) {
        switch (i) {
          case "projectName":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请输入项目名称");
              document
                .querySelector("#one")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "college":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择所在学院");
              document
                .querySelector("#one")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "state":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择项目状态");
              document
                .querySelector("#two")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "begin_at":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择项目开始时间");
              document
                .querySelector("#three")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "plannedEnd_at":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请选择计划完成时间");
              document
                .querySelector("#three")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "pro_leader":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请输入项目负责人");
              document
                .querySelector("#four")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          case "lead_leader":
            if (cEmpty.test(this.wordData[i])) {
              this.$message.error("请输入学院牵头领导");
              document
                .querySelector("#four")
                .scrollIntoView({ behavior: "smooth" });
              return false;
            }
            break;
          // case "teacher":
          //   if (this.wordData[i].length < 3) {
          //     this.$message.error("教师团队应3人以上");
          //     document
          //       .querySelector("#five")
          //       .scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   } else {
          //     let num = 0;
          //     this.wordData[i].forEach((item) => {
          //       if (cEmpty.test(item["name"])) num++;
          //     });
          //     if (num > 0) {
          //       this.$message.error("教师姓名请不要留空");
          //       document
          //         .querySelector("#five")
          //         .scrollIntoView({ behavior: "smooth" });
          //       return false;
          //     }
          //   }
          //   break;
          // case "student":
          //   if (this.wordData[i].length < 5) {
          //     this.$message.error("学生团队应5人以上");
          //     document
          //       .querySelector("#six")
          //       .scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   } else {
          //     let num = 0;
          //     this.wordData[i].forEach((item) => {
          //       if (cEmpty.test(item["name"])) num++;
          //       // for(let j in item){
          //       //   if(cEmpty.test(item[j])){
          //       //     num++;
          //       //   }
          //       // }
          //     });
          //     if (num > 0) {
          //       this.$message.error("学生姓名请不要留空");
          //       document
          //         .querySelector("#six")
          //         .scrollIntoView({ behavior: "smooth" });
          //       return false;
          //     }
          //   }
          //   break;
          case "fund":
            if (this.wordData["fund"]["total"] == 0) {
              // console.log(document.querySelector('#fund'))
              document
                .querySelector("#fund")
                .scrollIntoView({ behavior: "smooth" });
              return this.$message.error("请输入预算经费");
            }
            break;
          // case "brief":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写项目简介");
          //     document.querySelector('#seven').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }else{
          //     if(this.wordData[i].length<200||this.wordData>300){
          //       this.$message.error("项目简介需要200-300字")
          //       document.querySelector('#seven').scrollIntoView({ behavior: "smooth" });
          //       return false;
          //     }
          //   }
          //   break;
          // case "Construction":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写建设内容");
          //     document.querySelector('#eight').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "ProjectBasis":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写立项依据");
          //     document.querySelector('#nine').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "development":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写创客空间物理环境、制度建设及软件设施建设情况");
          //     document.querySelector('#ten').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "studio":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写学生创客工作室建设情况");
          //     document.querySelector('#eleven').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "studentTeam":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写学生创客团队（人才）培养预期成果、数量");
          //     document.querySelector('#twelve').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "studentActivities":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写学生创客活动组织实施情况");
          //     document.querySelector('#thirteen').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "Transforming":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写学生创客团队孵化、转化创业项目情况");
          //     document.querySelector('#fourteen').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break;
          // case "condition":
          //   if(cEmpty.test(this.wordData[i])){
          //     this.$message.error("请填写基础条件");
          //     document.querySelector('#fifteen').scrollIntoView({ behavior: "smooth" });
          //     return false;
          //   }
          //   break
        }
      }
      this.submitHint = true;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="less">
#MakerSpaceWordDetail {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
